import randomColor from "randomcolor";
import React, { Fragment } from "react";
import { NavLink } from "react-router-dom";
import Logo from "./logo";
const MainNavbar = () => {
  //تولید رنگ تصادفی
  const color = randomColor();
  return (
    <Fragment>
      <nav
        id="primary_nav_wrap"
        className="navbar navbar-expand-sm navbar-toggleable-sm navbar-dark bg-primary border-bottom box-shadow mb-3"
      >
        <div>
          <NavLink
            exact
            data-tip
            data-for="managments"
            className="navbar-brand"
            to="/"
          >
            <Logo />
          </NavLink>
        </div>
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarNavDropdown"
          aria-controls="navbarNavDropdown"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNavDropdown">
          <ul className="navbar-nav">
            <li className="nav-item ">
              <NavLink
                to="/"
                exact
                className="nav-link"
                style={{ color: "white" }}
                activeStyle={{ color: `${color}` }}
              >
                خانه
              </NavLink>
            </li>
            <li className="nav-item ">
              <a
                href="http://sms.sayyehban.ir/"
                className="nav-link"
                style={{ color: "white" }}
                activeStyle={{ color: `${color}` }}
              >
                ورود به سامانه
              </a>
            </li>
            <li className="nav-item ">
              <NavLink
                to="/FacilitiesAndTariffs"
                className="nav-link"
                style={{ color: "white" }}
                activeStyle={{ color: `${color}` }}
              >
                امکانات و تعرفه ها
              </NavLink>
            </li>
            <li className="nav-item ">
              <NavLink
                to="/VOPInfo"
                className="nav-link"
                style={{ color: "white" }}
                activeStyle={{ color: `${color}` }}
              >
                تلفن ثابت و ابری
              </NavLink>
            </li>
            <li id="BasicInformation" className="dropdown-submenu">
              <NavLink
                className="nav-link bg-bg-primary text-white dropdown-item dropdown-toggle"
                to="#"
              >
                نمایندگی
              </NavLink>
              <ul className="dropdown-menu">
                <li id="Reseller">
                  <NavLink
                    className="nav-link bg-white text-dark dropdown-item"
                    to="/Reseller"
                    activeStyle={{ color: `${color}` }}
                  >
                    پلن های نمایندگی
                  </NavLink>
                </li>
                <li id="OptionsIncome">
                  <NavLink
                    className="nav-link bg-white text-dark dropdown-item"
                    to="/OptionsIncome"
                  >
                    توجه درآمد نمایندگان
                  </NavLink>
                </li>
              </ul>
            </li>
            <li className="nav-item ">
              <a
                href="http://sms.sayyehban.ir/register.jspd"
                className="nav-link"
                style={{ color: "white" }}
                activeStyle={{ color: `${color}` }}
              >
                ثبت نام آنلاین
              </a>
            </li>
            <li className="nav-item ">
              <NavLink
                to="/Numbers"
                className="nav-link"
                style={{ color: "white" }}
                activeStyle={{ color: `${color}` }}
              >
                تعرفه خطوط
              </NavLink>
            </li>
            <li className="nav-item ">
              <NavLink
                to="/ContactUS"
                className="nav-link"
                style={{ color: "white" }}
                activeStyle={{ color: `${color}` }}
              >
                تماس با ما
              </NavLink>
            </li>
          </ul>
        </div>
      </nav>
    </Fragment>
  );
};

export default MainNavbar;
